import { render, staticRenderFns } from "./PrivacyProtectConcept.vue?vue&type=template&id=46d577e2&scoped=true&"
import script from "./PrivacyProtectConcept.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtectConcept.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtectConcept.vue?vue&type=style&index=0&id=46d577e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d577e2",
  null
  
)

export default component.exports